{
  "name": "@wild-moose/moose-cli",
  "version": "0.2.6",
  "description": "Wild Moose's command-line interface",
  "license": "MIT",
  "type": "module",
  "engines": {
    "node": ">= 18.12 <=22"
  },
  "bin": {
    "moose": "./build/index.js"
  },
  "main": "./build/index.js",
  "types": "./build/index.d.ts",
  "exports": {
    ".": {
      "import": "./build/index.js",
      "types": "./build/index.d.ts"
    }
  },
  "files": [
    "build"
  ],
  "scripts": {
    "dev": "tsx --inspect=0.0.0.0:9229 src/index.ts",
    "dev:ui": "vite --config ui/vite.config.ts",
    "start": "node build/index.js",
    "clean": "rimraf coverage build dist tmp",
    "prebuild": "pnpm run eslint",
    "build": "tsup && pnpm run build:ui",
    "build:ui": "vite build --config ui/vite.config.ts",
    "build:bundle": "esbuild ./src/index.ts --bundle --platform=node --target=node22 --outfile=dist/binary/index.js --external:@napi-rs/keyring --external:@napi-rs/*",
    "build:binaries": "pnpm run build:bundle && pnpm run build:binary:linux && pnpm run build:binary:macos-intel && pnpm run build:binary:macos-arm && pnpm run build:binary:windows",
    "build:binary:linux": "pkg dist/binary/index.js --output dist/binaries/linux-x64/moose --targets node18-linux-x64",
    "build:binary:macos-intel": "pkg dist/binary/index.js --output dist/binaries/macos-x64/moose --targets node18-macos-x64",
    "build:binary:macos-arm": "pkg dist/binary/index.js --output dist/binaries/macos-arm64/moose --targets node18-macos-arm64",
    "build:binary:windows": "pkg dist/binary/index.js --output dist/binaries/win-x64/moose.exe --targets node18-win-x64",
    "sign:macos": "if [ \"$(uname)\" = \"Darwin\" ]; then codesign --sign - --force dist/binaries/macos-x64/moose dist/binaries/macos-arm64/moose 2>/dev/null || true; fi",
    "eslint": "eslint . --ext .ts --ext .mts --cache",
    "prepack": "pnpm run clean && pnpm run build",
    "prepare": "pnpm audit --prod --audit-level=high",
    "prettier": "prettier --config .prettierrc --write .",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage"
  },
  "pre-commit": [
    "prebuild",
    "build",
    "test"
  ],
  "pkg": {
    "assets": [
      "node_modules/.pnpm/@napi-rs+keyring@*/**/*",
      "node_modules/.pnpm/@napi-rs+keyring-darwin-arm64@*/**/*",
      "node_modules/.pnpm/@napi-rs+keyring-darwin-x64@*/**/*",
      "node_modules/.pnpm/@napi-rs+keyring-linux-x64-gnu@*/**/*",
      "node_modules/.pnpm/@napi-rs+keyring-win32-x64-msvc@*/**/*"
    ],
    "scripts": []
  },
  "dependencies": {
    "@inquirer/prompts": "^8.2.0",
    "@modelcontextprotocol/sdk": "^1.30.0",
    "@napi-rs/keyring": "^1.2.0",
    "axios": "^1.19.0",
    "chalk": "^5.6.2",
    "commander": "^12.1.0",
    "dd-trace": "^5.119.0",
    "express": "^5.2.1",
    "graphql": "^16.12.0",
    "jest-diff": "^30.2.0",
    "lodash-es": "^4.18.0",
    "openid-client": "^6.8.1",
    "yaml": "^2.8.2",
    "zod": "^3.25.76"
  },
  "devDependencies": {
    "@auth0/auth0-react": "^2.15.0",
    "@fastify/pre-commit": "^2.2.1",
    "@napi-rs/keyring-darwin-x64": "^1.2.0",
    "@tailwindcss/vite": "^4.2.4",
    "@types/chalk": "^0.4.31",
    "@types/express": "^5.0.6",
    "@types/jest": "~29.5",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "~22",
    "@types/react": "^18.3.3",
    "@types/react-dom": "^18.3.0",
    "@typescript-eslint/eslint-plugin": "^8.17.0",
    "@typescript-eslint/parser": "^8.17.0",
    "@vitejs/plugin-react": "^4.3.1",
    "@yao-pkg/pkg": "^5.16.1",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "date-fns": "^4.1.0",
    "esbuild": "^0.27.0",
    "eslint": "^8.56.0",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-config-prettier": "~9.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jest": "^28.9.0",
    "eslint-plugin-prettier": "^5.2.1",
    "jest": "~29.7",
    "lucide-react": "^1.11.0",
    "prettier": "~3.2",
    "radix-ui": "^1.4.3",
    "react": "^18.3.1",
    "react-day-picker": "^9.14.0",
    "react-dom": "^18.3.1",
    "react-router-dom": "^7.13.1",
    "rimraf": "~5.0",
    "shadcn": "^4.5.0",
    "tailwind-merge": "^3.5.0",
    "tailwindcss": "^4.2.4",
    "ts-jest": "~29.2",
    "tslib": "^2.8.1",
    "tsup": "^8.5.1",
    "tsx": "^4.19.2",
    "tw-animate-css": "^1.4.0",
    "typescript": "^5.7.2",
    "vite": "^7.0.0"
  },
  "packageManager": "pnpm@10.24.0"
}
